export default __webpack_public_path__ + "static/media/spaces_in_dubai_256.365d35ba.jpg";